import Image from '@/components/UI/Image';
import EFDelta2EventAni4 from '@/components/UI/svg/Delta2/Icon/EFDelta2EventAni4';
import EFDelta2EventAni5 from '@/components/UI/svg/Delta2/Icon/EFDelta2EventAni5';
import EFDelta2EventAni6 from '@/components/UI/svg/Delta2/Icon/EFDelta2EventAni6';
import { useGlobal } from '@/utils/useGlobal';
import css from './index.module.scss';
export default function Delta2Group2() {
    const { useLang } = useGlobal();
    const { t } = useLang('delta2portablepowerstationevent');

    const data = [
        {
            title: t('group2-title1'),
            desc: t('group2-desc1'),
            mainImg: '/img/delta2Activilypage/delta2_1.jpg',
            avatarImg: '/img/delta2Activilypage/delta2_avatar_1.jpg',
            username: t('group2-name1'),
            talkText: t('group2-talk1'),
            icon: <EFDelta2EventAni4 />,
        },
        {
            title: t('group2-title2'),
            desc: t('group2-desc2'),
            mainImg: '/img/delta2Activilypage/delta2_2.jpg',
            avatarImg: '/img/delta2Activilypage/delta2_avatar_2.jpg',
            username: t('group2-name2'),
            talkText: t('group2-talk2'),
            icon: <EFDelta2EventAni5 />,
        },
        {
            title: t('group2-title3'),
            desc: t('group2-desc3'),
            mainImg: '/img/delta2Activilypage/delta2_3.jpg',
            avatarImg: '/img/delta2Activilypage/delta2_avatar_3.jpg',
            username: t('group2-name3'),
            talkText: t('group2-talk3'),
            icon: <EFDelta2EventAni6 />,
        },
    ];

    return (
        <div className={css.delta2_p2}>
            {data.map((item, i) => (
                <div className={`card-item item${i + 1}`} key={i}>
                    <div className="word-container">
                        <div className="title-wrap">
                            <div className="line-bg1 img-wrap">{item.icon}</div>
                            <h5 className="title">{item.title}</h5>
                        </div>
                        <div className="desc">{item.desc}</div>
                    </div>
                    <div className="img-container">
                        <div className="main-img img-wrap">
                            <Image src={item.mainImg} layout="fill" alt="" />
                        </div>
                        <div className="tip">
                            <div className="avatar-img img-wrap">
                                <Image src={item.avatarImg} className="fullImgs" layout="fill" alt="" />
                                <span className="username">{item.username}</span>
                            </div>
                            <div className="talk">
                                <span className="tag left">“</span>
                                <div>
                                    <span>{item.talkText}</span>
                                    <span className="tag right">”</span>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            ))}
        </div>
    );
}
